import {
  POST_BIRTH_DETAILS_INPUT,
  POST_BIRTH_DETAILS_INPUT_SUCCESS,
  POST_BIRTH_DETAILS_INPUT_FAIL,
  GET_BIRTH_CHART_LIST_SUCCESS,
  GET_BIRTH_CHART_LIST_FAIL,
  GET_BIRTH_CHART_SUCCESS,
  GET_BIRTH_CHART_FAIL,
  GET_PLACES_SUCCESS,
  GET_PLACES_FAIL,
  GET_PLACES_API_TOKEN,
  GET_PLACES_API_TOKEN_SUCCESS,
  GET_PLACES_API_TOKEN_FAIL,
  CLEAR_PLACES,
  SET_PLACE_KEYWORD,
  CLEAR_PLACE_KEYWORD,
  GET_BIRTH_CHART_PDF_SUCCESS,
  GET_BIRTH_CHART_PDF_FAIL,
  GET_BIRTH_CHART_LIST
} from "./actionTypes"

import { RESULT_OK, RESULT_ERROR } from "../baseActionTypes"

const INIT_STATE = {
  error: {},
  loading: false,
  actionResult: {},
  placeKeyword: '',
  places: [],
  userBirthChartListPage: {},
  placesToken: '',
  userBirthDetailsInput: {}
}

const projects = (state = INIT_STATE, action) => {
  switch (action.type) {
    case POST_BIRTH_DETAILS_INPUT:
      return {
        ...state,
        loading: true,
        userBirthDetailsInput: action.payload,
      }

    case POST_BIRTH_DETAILS_INPUT_SUCCESS:
      return {
        ...state,
        userBirthDetailsInput: action.payload,
        actionResult: { action: POST_BIRTH_DETAILS_INPUT, result: RESULT_OK, error: '' },
        loading: false,
      }

    case POST_BIRTH_DETAILS_INPUT_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: POST_BIRTH_DETAILS_INPUT, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    case GET_BIRTH_CHART_LIST_SUCCESS:
      return {
        ...state,
        userBirthChartListPage: action.payload,
        actionResult: { action: GET_BIRTH_CHART_LIST, result: RESULT_OK, error: '' },
        loading: false,
      }

    case GET_BIRTH_CHART_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_BIRTH_CHART_LIST, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    case GET_BIRTH_CHART_SUCCESS:
      return {
        ...state,
        birthChart: action.payload,
        actionResult: { action: GET_BIRTH_CHART_SUCCESS, result: RESULT_OK, error: '' }
      }

    case GET_BIRTH_CHART_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_BIRTH_CHART_FAIL, result: RESULT_ERROR, error: action.payload }
      }

    case GET_PLACES_SUCCESS:
      return {
        ...state,
        places: action.payload,
        actionResult: { action: GET_PLACES, result: RESULT_OK, error: '' }
      }

    case GET_PLACES_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_PLACES, result: RESULT_ERROR, error: action.payload }
      }

    case CLEAR_PLACES:
      return {
        ...state,
        places: [],
        actionResult: { action: CLEAR_PLACES, result: RESULT_ERROR, error: action.payload }
      }

    case SET_PLACE_KEYWORD:
      return {
        ...state,
        placeKeyword: action.payload,
        actionResult: { action: SET_PLACE_KEYWORD, result: RESULT_OK, error: '' }
      }

    case CLEAR_PLACE_KEYWORD:
      return {
        ...state,
        placeKeyword: '',
        actionResult: { action: CLEAR_PLACE_KEYWORD, result: RESULT_OK, error: '' }
      }

    case GET_BIRTH_CHART_PDF_SUCCESS:
      return {
        ...state,
        birthChartPDFStatus: action.payload,
        actionResult: { action: GET_BIRTH_CHART_PDF, result: RESULT_OK, error: '' }
      }

    case GET_BIRTH_CHART_PDF_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_BIRTH_CHART_PDF, result: RESULT_ERROR, error: action.payload }
      }

    case GET_PLACES_API_TOKEN_SUCCESS:
      return {
        ...state,
        placesToken: action.payload,
        actionResult: { action: GET_PLACES_API_TOKEN, result: RESULT_OK, error: '' }
      }

    case GET_PLACES_API_TOKEN_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_PLACES_API_TOKEN, result: RESULT_ERROR, error: action.payload }
      }

    default:
      return state
  }
}

export default projects
